'use strict';

const scrollAnimate = require('base/components/scrollAnimate');
const wishlist = require('../product/wishlist');
const addProductToWishlistStorage = wishlist.methods.addProductToWishlistStorage;
const { get } = require('lodash');
let miniCartUpdateSource = false;

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    let $body = $('body');
    const $lineItem = $('.uuid-' + uuid);
    const $productImg = $lineItem.find('.cart-lineitem-image').clone();
    const $productPrice = $lineItem.find('.cart-lineitem-price').clone();
    const $successRemoveProductModal = $('.success-remove-product-modal');

    const $deleteConfirmBtn = $('.cart-delete-confirmation-btn');

    $deleteConfirmBtn.attr('data-pid', productID);
    $deleteConfirmBtn.attr('data-action', actionUrl);
    $deleteConfirmBtn.attr('data-uuid', uuid);

    $('.remove-product-modal .product-to-remove').empty().append(productName);
    $('.remove-product-modal .product-to-remove-img').empty().append($productImg);
    $('.remove-product-modal .product-to-remove-price').empty().append($productPrice);
    if ($successRemoveProductModal.length) {
        $successRemoveProductModal.find('.product-name').empty().append(productName);
        $('body').trigger('removeProduct:success');
    }

    if ($('.minicart-overlay-wrapper').hasClass('active') && $('.remove-product-modal').has('show')) {
        $body.addClass('move-to-wishlist-modal-open');
    }

    let $removeProductModal = $('.remove-product-modal');
    if ($removeProductModal.length) {
        $removeProductModal.appendTo('body');
    }
}

/**
 * Updates the cart top message container with limit messages.
 * @param {string[]} limitMessages - An array of messages to display in the cart top message container.
 */
function updateLimitMessages(limitMessages) {
    if (limitMessages) {
        const $cartProductLimit = $('.cart-top-product-limit');
        $cartProductLimit.empty();
        if (limitMessages.length) {
            limitMessages.forEach(function (msg) {
                $cartProductLimit.append(`<p>${msg}</p>`);
            });
            scrollAnimate($('.cartmain'));
        }
    }
}

/**
 * Updates the product Limit Model with limit messages.
 * @param {string[]} limitMessages - An array of messages to display in the cart top message container.
 */
function updateProductLimitModel(limitMessages) {
    if (limitMessages && $('#minicart-overlay-slider').hasClass('active')) {
        if (limitMessages.length) {
            const $lineItemModel = $('.minicart .product-limit-modal').last();
            limitMessages.forEach(function (msg) {
                $lineItemModel.find('.modal-body').text(msg);
            });
            $lineItemModel.modal('show');
        }
    }
}

/**
 * Appends query parameters to a given URL.
 *
 * @param {string} url - The base URL.
 * @param {Object} params - An object containing key-value pairs to append.
 * @returns {string} - The updated URL with appended query parameters.
 */
function appendToUrl(url, params) {
    const queryString = Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

    return url + (url.includes('?') ? '&' : '?') + queryString;
}

/**
 * Updates the quantity in UI.
 */
function updateQuantityUI() {
    $('.cart-lineitem-qty-wrapper').each(function () {
        const $container = $(this);
        const inputVal = $container.find('.quantity').val();
        if (inputVal) {
            $container.find('.cart-lineitem-qty-value').text(inputVal);
        }
    });
}

/**
 * Validates the basket and updates the UI accordingly.
 * If the basket is invalid, it displays an error message and disables the checkout button.
 *
 * @param {Object} data - The AJAX response from the server.
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            const errorHtml = `
                <div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    ${data.valid.message}
                </div>
            `;
            $('.cart-error').append(errorHtml);
        } else {
            const emptyCartHtml = `
                <div class="row">
                    <div class="col-12 text-center">
                        <h1>${data.resources.emptyCartMsg}</h1>
                    </div>
                </div>
            `;
            $('.cart').empty().append(emptyCartHtml);
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems,
            });
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the Shipping totals in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateShippingTotals(data) {
    const $shippingCost = $('.shipping-cost');
    const totals = data.totals || (data.basket && data.basket.totals);
    if (totals) {
        if (totals.adjustedShippingTotalPrice && totals.adjustedShippingTotalPrice.value === 0) {
            const freeMsg = $shippingCost.attr('data-free-ship-msg');
            $shippingCost.empty().append(freeMsg);
        } else if (totals.adjustedShippingTotalPrice && totals.adjustedShippingTotalPrice.value > 0) {
            $shippingCost.empty().append(totals.adjustedShippingTotalPrice.formatted);
        } else {
            $shippingCost.empty().append(totals.totalShippingCost);
        }
    }

    if (totals && totals.shippingLevelDiscountTotal && totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-without-discount-total').empty().append(totals.totalShippingCost);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.cart-title-wrapper .cart-count .count-text').empty().append(data.numItems);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.sub-total-discount').empty().append(data.totals.subTotalDiscounted);

    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems,
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total')
            .empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }
    updateShippingTotals(data);

    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID)
                .empty()
                .append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price')
            .empty()
            .append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price')
            .empty()
            .append(item.renderedPrice);
        $('.item-total-' + item.UUID)
            .empty()
            .append(item.priceTotal.renderedPrice);
    });
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    let messages = '';

    let lineItem = data.items.find((item) => item.UUID === uuid);

    if (lineItem !== null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += `<p class="line-item-attributes"> ${message} </p>`;
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += `<p class="line-item-attributes line-item-instock-date"> ${lineItem.availability.inStockDate} </p>`;
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}
/**
 * Displays an error notification in the cart.
 *
 * @param {string} message - The error message to display.
 */
function createErrorNotification(message) {
    const errorHtml = `
        <div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            ${message}
        </div>
    `;

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    var $approachingDiscounts = $('.approaching-discounts');
    $approachingDiscounts.empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
        });
    }
    $approachingDiscounts.append(html);
}

module.exports = function () {
    const $document = $(document);
    const $body = $('body');
    const $window = $(window);
    const $promoModal = $('.promo-applied-successfully');
    const specialMsgArray = [];

    $document.on('click', '.checkout-continue', function (e) {
        const $this = $(this);
        const $checkout = $this.find('.btn.btn-primary.btn-block.checkout-btn');
        const isDisabled = $checkout.hasClass('disabled');
        const enablecheckoutbtntrack = $this.data('enablecheckoutbtntrack');

        if (enablecheckoutbtntrack && 'dataLayer' in window && window.dataLayer && !isDisabled) {
            e.preventDefault();
            const dataUrl = $this.data('url');
            const checkoutURL = $checkout.attr('href');
            $.ajax({
                url: dataUrl,
                type: 'GET',
                data: {},
                success: function (data) {
                    if (data.success) {
                        $('body').trigger('gtm:add:event', data);
                    }
                    window.location.href = checkoutURL;
                },
                error: function () {
                    window.location.href = checkoutURL;
                },
            });
        }
    });

    $('.cart-lineitem-messages p').each(function () {
        const $this = $(this);
        let itemuuid = $(this).closest('.cart-lineitem-messages').attr('data-itemuuid');
        if (!$this.hasClass('lithium-batteries-msg')) {
            const msg = `<p class="${itemuuid}">${$this.html()}</p>`;
            if (!specialMsgArray.includes(msg)) {
                specialMsgArray.push(msg);
            }
        }
    });

    $('.special-message-region').append(specialMsgArray.join(''));

    updateQuantityUI();

    $body.on('cart:update promotion:success', function (e, data) {
        const tempData = 'basket' in data ? data.basket : data;
        if (tempData.cartLineItemsHtml) {
            $('.cart-left-wrapper').html(tempData.cartLineItemsHtml);
        }

        if ('totals' in tempData && 'discountsHtml' in tempData.totals && tempData.totals.discountsHtml) {
            $('.promo-code-form .coupon-field-wrapper').empty().append($(tempData.totals.discountsHtml).html());
        }

        updateShippingTotals(data);
    });

    $body.on('cart:update', function (e, data) {
        updateQuantityUI();
        const limitMessages = data.limitMessages || [];
        if (data.basket && data.basket.valid && data.basket.valid.error) {
            limitMessages.push(data.basket.valid.message);
        }
        updateLimitMessages(limitMessages);
        updateProductLimitModel(data.limitMessages || []);
        if (data.basket && data.basket.items.length !== 0) {
            $('.minicart-overlay-wrapper .count-text .ajax-count').html(data.basket.numItems);
        }
        if (data.numItems) {
            $('.cart-title-wrapper .cart-count .count-text').empty().append(data.numItems);
        }
        if (data.queryString) {
            const uuid = new URLSearchParams(data.queryString).get('uuid');
            const $incrementBtn = $(`.uuid-${uuid} .cart-lineitem-increment`);
            $incrementBtn.addClass('loading');
            setTimeout(function () {
                $incrementBtn.removeClass('loading');
            }, 1000);
        }

        if (miniCartUpdateSource) {
            $body.trigger('minicart:update', { keepMiniCartOpen: true });
            miniCartUpdateSource = false;
        } else {
            $body.trigger('minicart:update');
        }

        const $wishlistBtn = $('.cart-wishlist-confirmation-btn');
        if ($wishlistBtn.hasClass('active')) {
            $wishlistBtn.removeClass('active');
            const url = $wishlistBtn.data('addWishlistUrl');
            const pid = $wishlistBtn.data('pid');
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    pid: pid,
                },
                success: function () {
                    $('.wishlist-confirmation-modal').modal('hide');
                    $('.cart-wishlist-success-modal').modal('show');
                    addProductToWishlistStorage(pid);
                },
                error: function () {
                    $('.wishlist-confirmation-modal').modal('hide');
                },
            });
        }
        if (data.basket && data.basket.items.length === 0) {
            if (!$('.minicart').hasClass('minicart-open') && !$('.minicart-overlay-wrapper').hasClass('active')) {
                addProductToWishlistStorage($wishlistBtn.data('pid'));
                window.location.reload();
            }
        }
    });

    $document.on('ajaxComplete', function (event, xhr) {
        updateLimitMessages(xhr.responseJSON && xhr.responseJSON.limitMessages ? xhr.responseJSON.limitMessages : null);
        if ($('#minicart-overlay-slider').hasClass('active')) {
            updateProductLimitModel(xhr.responseJSON && xhr.responseJSON.limitMessages ? xhr.responseJSON.limitMessages : null);
        }
    });

    $document.on('click', '.cart-lineitem-increment, .cart-lineitem-decrement', function () {
        let $this = $(this);
        if ($(this).hasClass('cart-lineitem-decrement')) {
            $this.closest('.cart-lineitem-qty-wrapper').find('.quantity').val(-1).change();
        } else {
            $this.closest('.cart-lineitem-qty-wrapper').find('.quantity').val(1).change();
        }
        if ($this.closest('.minicart-overlay-wrapper').length) {
            miniCartUpdateSource = true;
        }
    });

    $document.on('click', '.cart-lineitem-multi-increment', function () {
        let element = $(this);
        let dialogUrl = element.data('dialogUrl');
        $.ajax({
            url: dialogUrl,
            type: 'get',
            success: function (data) {
                let newModal = $(data);
                element.closest('.cart-lineitem-qty-wrapper').after(newModal);
                $('#newQtyBox').modal('show');
                $('#newQtyBox').on('hidden.bs.modal', function () {
                    let newQty = $('#newQtyBox').find('#newQtyValue').val();
                    if (parseInt(newQty, 10)) {
                        element.closest('.cart-lineitem-qty-wrapper').find('.quantity').val(newQty).change();
                    }
                    $('#newQtyBox').remove();
                });
            },
        });
    });

    $body.on('removeProduct:success', function () {
        const $successRemoveProductModal = $('.success-remove-product-modal');
        $successRemoveProductModal.modal('show');
        $('.modal-backdrop').hide();
        $successRemoveProductModal.addClass('show');
        if ($successRemoveProductModal.hasClass('show')) {
            $('.modal-backdrop').addClass('success-remove-product-modal-open');
        }
    });

    $body.on('click', '.delete-coupon-confirmation-btn', function () {
        $promoModal.addClass('promo-remove-model');
    });

    $promoModal.on('hidden.bs.modal', function () {
        $promoModal.removeClass('promo-remove-model');
    });

    $body.on('promotion:error', function (e, data) {
        $('.promo-error-modal').modal('show');
        $promoModal.removeClass('promo-remove-model');
        if (data.queryString) {
            const couponCode = new URLSearchParams(data.queryString).get('couponCode');
            if (couponCode) {
                setTimeout(function () {
                    $('.coupon-code-field').val(couponCode);
                }, 0);
            }
        }
    });

    $body.on('promotion:success', function (e, data) {
        const discounts = data?.totals?.discounts || [];
        const $deletePromoBtn = $('.delete-coupon-confirmation-btn');
        const $couponInput = $('.coupon-code-field');
        const $promoCodeBtn = $('.promo-code-btn');

        let couponCode = '';
        let uuid = '';

        if (discounts.length) {
            const discountFound = discounts.find((discount) => discount.type === 'coupon' && discount.applied);
            if (discountFound) {
                couponCode = discountFound.couponCode || '';
                uuid = discountFound.UUID || '';
            }
        }

        $deletePromoBtn.toggleClass('d-none', !couponCode);
        $promoCodeBtn.prop('disabled', !!couponCode);
        setTimeout(function () {
            $couponInput.prop('disabled', !!couponCode).val(couponCode);
        }, 0);
        $deletePromoBtn.data({ code: couponCode, uuid: uuid });

        $promoModal.modal('show');

        if (data.totals && data.totals.subTotalDiscounted && data.totals.subTotal) {
            $('.sub-total-discount')
                .text(data.totals.subTotalDiscounted)
                .toggleClass('hide-shipping-discount', data.totals.subTotal === data.totals.subTotalDiscounted);
            $('.sub-total')
                .text(data.totals.subTotal)
                .toggleClass('text-decoration-line-through lr-m', data.totals.subTotal !== data.totals.subTotalDiscounted);
        }
        $('body').trigger('gtm:add:event', { datalayer: get(data, 'datalayer', []) });
    });

    $body.on('input', '.coupon-code-field', function () {
        const $this = $(this);
        if ($this.val()) {
            $this.removeClass('is-invalid');
            $('.promo-code-form').removeClass('invalid-promo');
        }
    });

    $('.promo-code-form').submit(function () {
        if (!$('.coupon-code-field').val()) {
            $('.promo-error-modal').modal('show');
        }
    });

    $body.on('click', '.clear-cupon-code', function () {
        $('.coupon-code-field').val('').removeClass('is-invalid');
        $('.promo-code-form').removeClass('invalid-promo');
    });

    $body.off('click', '.remove-product').on('click', '.remove-product', function (e) {
        e.preventDefault();
        const $this = $(this);

        var actionUrl = $this.data('action');
        var productID = $this.data('pid');
        var productName = $this.data('name');
        var uuid = $this.data('uuid');

        $('body').trigger('gtm:hook', { targetGtmEl: $('.cart-delete-confirmation-btn'), productId: productID, context: 'REMOVE_FROM_CART' });
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $body.on('click', '.js-remove-product', function () {
        const $this = $(this);
        let actionUrl = $this.data('action');
        let productID = $this.data('pid');
        let uuid = $this.data('uuid');
        let productName = $this.data('name');
        const $deleteConfirmBtn = $('.remove-product-modal .cart-delete-confirmation-btn');
        $deleteConfirmBtn.attr('data-pid', productID);
        $deleteConfirmBtn.attr('data-action', actionUrl);
        $deleteConfirmBtn.attr('data-uuid', uuid);
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $body.on('click', '.move-product-wishlist-link', function () {
        var uuid = $(this).attr('data-uuid');
        var productID = $(this).attr('data-pid');
        var actionUrl = $(this).attr('data-action');
        const $lineItem = $('.uuid-' + uuid);
        const undoBtn = $('.cart-undo-wishlist-btn');
        undoBtn.attr('data-pid', productID);
        const $productImg = $lineItem.find('.cart-lineitem-image').clone();
        const productName = $lineItem.find('.cart-lineitem-name').text();
        const $wishListConfirmBtn = $('.cart-wishlist-confirmation-btn');
        $wishListConfirmBtn.attr('data-pid', productID);
        $wishListConfirmBtn.attr('data-uuid', uuid);
        $wishListConfirmBtn.attr('data-action', actionUrl);
        $('body').trigger('gtm:hook', { targetGtmEl: $('.cart-wishlist-confirmation-btn'), productId: productID, context: 'WISHLIST_ADD' });
        $('.cart-wishlist-success-modal .product-wishlist-img').empty().append($productImg);
        $('.cart-wishlist-success-modal .product-to-wishlist').empty().append(productName);
    });

    $body.on('click', '.cart-wishlist-confirmation-btn', function () {
        $(this).addClass('active');
    });

    $('body').on('click', '.cart-undo-wishlist-btn', function (e) {
        e.preventDefault();

        var $this = $(this);
        var pid = $this.data('pid');
        var addToCartUrl = $this.data('add-to-cart-url');

        var formData = {
            pid: pid,
            quantity: 1,
        };

        $.spinner().start();

        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: formData,
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    createErrorNotification(data.message);
                } else {
                    window.location.reload();
                    $.spinner().stop();
                }
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON?.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });

    $('body').on('click', '.cart-undo-wishlist-btn', function (e) {
        e.preventDefault();

        var $this = $(this);
        var pid = $this.data('pid');
        var removeFromWishlistUrl = $this.data('remove-from-wishlist-url');

        $.spinner().start();

        $.ajax({
            url: removeFromWishlistUrl,
            method: 'GET',
            data: { pid: pid },
            dataType: 'json',
            success: function (data) {
                if (data.error) {
                    createErrorNotification(data.message);
                } else {
                    window.location.reload(); // or update the DOM dynamically
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON?.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });
    /**
     * Updates the `cart` object in the global `window.dataLayer` array with new cart data.
     *
     * @param {Object} response - The response object containing updated cart data.
     * @param {Object} response.updatedCartData - The new cart data to be set in the dataLayer.
     */
    function getDataLayerCartData(response) {
        if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
            window.dataLayer = [{}]; // Initialize if not present
        }
        const updatedCartData = response.updatedCartData;
        if (!updatedCartData) return;
        let cartUpdated = false;
        for (let i = 0; i < window.dataLayer.length; i++) {
            if (window.dataLayer[i].cart) {
                window.dataLayer[i].cart = updatedCartData;
                cartUpdated = true;
                break;
            }
        }
        // If no existing cart object found, push a new one
        if (!cartUpdated) {
            window.dataLayer.push({ cart: updatedCartData });
        }
    }
    $body.off('click', '.cart-delete-confirmation-btn').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();
        var $this = $(this);
        var productID = $this.attr('data-pid');
        var isminicart = $this.attr('data-isminicart');
        var url = $this.attr('data-action');
        var uuid = $this.attr('data-uuid');
        var productName = $this.attr('data-name');
        var urlParams = {
            pid: productID,
            uuid: uuid,
            isminicart: isminicart,
        };
        url = appendToUrl(url, urlParams);
        $('body > .modal-backdrop').remove();
        $.spinner().start();
        $body.trigger('cart:beforeUpdate');
        $('.remove-product-modal').modal('hide');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems,
                    });
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    $('.' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }
                if (isminicart) {
                    $('body').trigger('gtm:add:event', { datalayer: get(data, 'datalayer', []) });
                }
                getDataLayerCartData(data);

                confirmDelete(url, productID, productName, uuid);
                $body.trigger('cart:update', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });

    $body.off('click', '.add-refill-cta').on('click', '.add-refill-cta', function (e) {
        e.preventDefault();
        var $refillModalBody = $('#refillProducts .modal-body');
        $refillModalBody.empty();
        var $cta = $(this);
        var actionUrl = $cta.data('action');
        var productID = $cta.data('pid');
        var uuid = $cta.data('uuid');

        $.spinner().start();

        $.ajax({
            url: actionUrl,
            type: 'get',
            data: { pid: productID, uuid: uuid },
            success: function (result) {
                var $html = $('<div>').append($.parseHTML(result.renderedTemplate));
                var $newModalData = $html.find('.modal-body');
                $refillModalBody.html($newModalData.html());
                $('#refillProducts').modal('show');

                $('.refill-products-modal .product-carousel').each(function () {
                    var $this = $(this);
                    if (!$this.hasClass('slick-initialized')) {
                        $this.slick({
                            dots: true,
                            arrows: false,
                            infinite: false,
                            lazyLoad: 'ondemand',
                            slidesToShow: 3.5,
                            speed: 500,
                            touchThreshold: 100,
                            slidesToScroll: 1,
                            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-icon"></i></button>',
                            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-icon"></i></button>',
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2.7,
                                        slidesToScroll: 1,
                                    },
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 1.4,
                                        slidesToScroll: 1,
                                    },
                                },
                            ],
                        });
                    }
                });
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            },
        });
    });

    $body.off('click', '.refill-products-modal .add-to-cart').on('click', '.refill-products-modal .add-to-cart', function (e) {
        e.preventDefault();
        const $this = $(this);
        const actionUrl = $this.data('action');
        const productID = $this.data('formPid');
        const quantity = $this.data('formQuantity');
        const addAgainCta = $this.data('addAgainCta');
        const lastItemStock = $this.data('lastItemStock');
        const outOfStockCta = $this.data('outOfStockCta');
        const pageLocation = $this.data('pagelocation');
        const pageSticky = $this.data('pagesticky');

        $.spinner().start();

        $.ajax({
            url: actionUrl,
            type: 'post',
            data: { pid: productID, quantity: quantity, page_location: pageLocation, page_sticky: pageSticky },
            success: function (response) {
                let addedQuantity = parseInt($this.attr('data-added-quantity'), 10);
                const $productAddSuccess = $this.closest('.product-tile-body').find('.success-msg-block');
                if (!response.error) {
                    if ($productAddSuccess.hasClass('d-none')) {
                        $productAddSuccess.removeClass('d-none');
                        $productAddSuccess.fadeIn(100);
                    }
                    if (response.cart && response.cart.items && response.cart.items.length > 0) {
                        const pli = response.cart.items.find((obj) => obj.id === productID);

                        if (pli.inventoryMsg === lastItemStock) {
                            // Item out of stock scenario (last item added)
                            $this.html(outOfStockCta).fadeIn(100);
                            $this.attr('disabled', 'disabled');
                        } else {
                            $this.fadeOut(100, function () {
                                $this.html(addAgainCta).fadeIn(100);
                            });
                        }
                    }
                    addedQuantity += 1;
                    $('.minicart').trigger('count:update', response);
                    $('.refill-products-modal').attr('data-product-added', 'true');
                } else {
                    $productAddSuccess.html(response.message);
                    $productAddSuccess.removeClass('d-none');
                    $productAddSuccess.fadeIn(100);
                    $this.html(addAgainCta).fadeIn(100);
                    $this.attr('disabled', 'disabled');
                }
                setTimeout(() => {
                    $productAddSuccess.fadeOut(500, () => {
                        $productAddSuccess.addClass('d-none');
                    });
                }, 3000);
                $this.attr('data-added-quantity', addedQuantity);
                if (addedQuantity > 1) {
                    $this.attr('disabled', 'disabled');
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            },
        });
    });

    $('#refillProducts').on('hide.bs.modal', function () {
        if ($(this).attr('data-product-added') === 'true') {
            window.location.reload();
        }
    });

    $body.on('change', '.js-giftwrap-checkbox', function () {
        const $this = $(this);
        const $modal = $('#cartGiftWrappingModal');
        const currentVal = $this.prop('checked');
        const isEditMode = !currentVal === true;

        // undo the effect, wait for the modal submit/close to happen
        $this.prop('checked', !currentVal);

        $('input[name="UUID"]', $modal).val($this.attr('data-uuid'));
        $('#cartGiftWrappingMessage', $modal).val(isEditMode ? decodeURIComponent($this.attr('data-text') || '') : '');
        $('#cartGiftWrappingFreeWrap', $modal).prop('checked', isEditMode ? $this.attr('data-has-free-gift-wrap') === 'true' : true);

        if (isEditMode) {
            $('.js-remove-gift-wrap', $modal).removeClass('d-none');
        } else {
            $('.js-remove-gift-wrap', $modal).addClass('d-none');
        }

        $modal.modal('show');
    });

    $body.on('click', '.js-edit-giftwrap', function (e) {
        e.preventDefault();
        $(this).closest('label').siblings('.js-giftwrap-checkbox').prop('checked', false).trigger('change');
        const oldMessage = $('#cartGiftWrappingMessage').val();
        const pid = $(this).data('pid') || '';
        const data = {
            oldMessage: oldMessage,
            pid: pid,
        };
        $('#editGiftWrap').val(JSON.stringify(data));
    });

    $('#cartGiftWrappingMessage').on('input', function () {
        let textarea = $(this);
        let value = textarea.val();
        const maxChars = parseInt($('#cartGiftWrappingMessage').attr('maxlength'), 10);
        const maxLines = parseInt($('#cartGiftWrappingMessage').attr('rows'), 10) + 1;

        // Enforce character limit
        if (value.length > maxChars) {
            textarea.val(value.substring(0, maxChars));
            value = textarea.val();
        }

        // Update character count display
        $('.instructions-text').text(value.length + ' / ' + maxChars + ' characters');

        // Count number of lines
        let lines = value.split('\n');
        if (lines.length > maxLines) {
            // Remove extra lines
            textarea.val(lines.slice(0, maxLines).join('\n'));
        }
    });

    $('#cartGiftWrappingModal')
        .off('click', '.js-remove-gift-wrap')
        .on('click', '.js-remove-gift-wrap', function (e) {
            const $this = $(this);
            const $modal = $this.closest('#cartGiftWrappingModal');
            e.preventDefault();
            const UUID = $('input[name="UUID"]', $modal).val();

            $.ajax({
                url: $this.attr('data-remove-url'),
                method: 'POST',
                data: {
                    UUID,
                },
                success: function () {
                    const $input = $(`.js-giftwrap-checkbox[data-uuid="${UUID}"]`);
                    $input.prop('checked', false);
                    $modal.modal('hide');
                },
            });
        });

    $('#cartGiftWrappingModal form').on('submit', function (e) {
        e.preventDefault();
        const $this = $(this);
        const formData = $this.serialize() + '&giftmsg=' + $('#cartGiftWrappingMessage').val() + '&editGiftWrap=' + $('#editGiftWrap').val();
        const $modal = $this.closest('#cartGiftWrappingModal');
        const url = $this.attr('action');

        $.ajax({
            url,
            method: 'POST',
            data: formData,
            success: function (response) {
                if (response.success && response.data) {
                    $('#editGiftWrap').val('');
                    const UUID = response.data.UUID;
                    const $input = $(`.js-giftwrap-checkbox[data-uuid="${UUID}"]`);
                    if (response.data.giftMessage) {
                        $input.attr('data-text', encodeURIComponent(response.data.giftMessage));
                    }
                    $input.attr('data-has-free-gift-wrap', response.data.freeGiftWrap);
                    $input.prop('checked', true);

                    $('body').trigger('gtm:add:event', response);
                }
                $modal.modal('hide');
            },
        });
    });

    $('.js-cart-gift-wrap-message')
        .off('keydown', '#cartGiftWrappingMessage')
        .on('keydown', '#cartGiftWrappingMessage', function (e) {
            let $this = $(this);
            let lines = $this.val().split(/\r\n|\r|\n/);

            // If Enter is pressed after 8 lines, block it
            if (e.key === 'Enter' && lines.length >= 8) {
                e.preventDefault();
                e.stopPropagation();
            }
        })

        .on('input', '#cartGiftWrappingMessage', function () {
            let $this = $(this);
            let $parent = $this.closest('.js-cart-gift-wrap-message');
            let length = $this.val().length;
            let maxlength = parseInt($this.attr('maxlength'), 10);

            $('.instructions-text span', $parent).html(maxlength - length);
        });

    const $cartSummaryWrapper = $('.cart-right-container');
    if ($('.cart-summary-toggle').length || $cartSummaryWrapper.length) {
        const cartEl = $cartSummaryWrapper[0];
        const observer = new IntersectionObserver(
            ([entry]) => {
                const viewportHeight = window.outerHeight;
                const windowTop = window.scrollY || window.pageYOffset;
                const containerOffset = $cartSummaryWrapper.offset().top;

                // If it's not fully visible and on small screens, make it sticky
                const isSticky = !entry.isIntersecting && (app.isMobile() || app.isTablet());
                $cartSummaryWrapper.toggleClass('sticky-cart-summary', isSticky);
                if (windowTop + viewportHeight > containerOffset + 100) {
                    $cartSummaryWrapper.removeClass('sticky-cart-summary');
                }
            },
            {
                root: null,
                threshold: 0.01,
            }
        );
        observer.observe(cartEl);
        // Toggle active class on click
        $document.on('click', '.cart-summary-toggle', function () {
            $(this).closest('.cart-right-container').toggleClass('active');
        });
        // Handle responsive changes
        $window.on('resize', function () {
            observer.unobserve(cartEl);
            observer.observe(cartEl);
        });
    }

    $('.promo-code-form')
        .off('submit')
        .on('submit', function (e) {
            e.preventDefault();
            $.spinner().start();
            $('.coupon-missing-error').hide();
            $('.coupon-error-message').empty();
            if (!$('.coupon-code-field').val()) {
                $('.promo-code-form .form-control').addClass('is-invalid');
                $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
                $('.coupon-missing-error').show();
                $.spinner().stop();
                return false;
            }
            var $form = $('.promo-code-form');
            $('.promo-code-form .form-control').removeClass('is-invalid');
            $('.promo-code-form').removeClass('invalid-promo');
            $('.coupon-error-message').empty();
            $('body').trigger('promotion:beforeUpdate');

            $.ajax({
                url: $form.attr('action'),
                type: 'GET',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $('.promo-code-form').toggleClass('invalid-promo', !!data.error);
                    if (data.error) {
                        $('.promo-code-form .form-control').addClass('is-invalid');
                        $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                        $('.coupon-error-message').empty().append(data.errorMessage);
                        $('body').trigger('promotion:error', data);
                    } else {
                        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        $('body').trigger('promotion:success', data);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    $('.promo-code-form').addClass('invalid-promo');
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
            return false;
        });

    $body.off('change', '.quantity-form > .quantity').on('change', '.quantity-form > .quantity', function () {
        const $this = $(this);
        let preSelectQty = $this.data('pre-select-qty');
        let quantity = $this.val();
        let productID = $this.data('pid');
        let url = $this.data('action');
        let uuid = $this.data('uuid');

        let urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid,
        };
        url = appendToUrl(url, urlParams);

        $this.parents('.card').spinner().start();

        $body.trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $this.data('pre-select-qty', quantity);

                $body.trigger('cart:update', data);

                $.spinner().stop();
                if ($this.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    window.location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $this.val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            },
        });
    });

    $('body')
        .off('click', '.delete-coupon-confirmation-btn')
        .on('click', '.delete-coupon-confirmation-btn', function (e) {
            e.preventDefault();

            var url = $(this).data('action');
            var uuid = $(this).data('uuid');
            var couponCode = $(this).data('code');
            var urlParams = {
                code: couponCode,
                uuid: uuid,
            };

            url = appendToUrl(url, urlParams);

            $('body > .modal-backdrop').remove();

            $.spinner().start();
            $('body').trigger('promotion:beforeUpdate');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.coupon-uuid-' + uuid).remove();
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $.spinner().stop();
                    $('body').trigger('promotion:success', data);
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
        });

    let $stickyCheckoutBtn = $('.js-sticky-checkout-button');
    if ($stickyCheckoutBtn.length > 0) {
        const debounce = require('lodash/debounce');
        let $wrapper = $stickyCheckoutBtn;
        let $target = $('.btn', $wrapper).first();
        let headerHeight = $('.reduced-header-component').outerHeight();
        let initialAtbPos = $wrapper.offset().top - headerHeight;
        let initialWidth = $wrapper.width();
        let bottomPadding = app.isDesktop() ? 16 : 8;
        let targetHeight = $target.outerHeight();

        const handleStickyCheckoutButton = function ($context) {
            let scrollTop = $context.scrollTop();

            if (scrollTop + window.innerHeight - headerHeight - targetHeight - bottomPadding < initialAtbPos) {
                if ($target.hasClass('cart-checkout-stick-bottom')) {
                    return;
                }
                $target.css('left', $wrapper.offset().left + 'px');
                $target.css('width', initialWidth + 'px');
                $target.removeClass('cart-checkout-fixed').addClass('cart-checkout-stick-bottom');
            } else {
                $target.css('width', initialWidth + 'px');
                $target.removeClass('cart-checkout-fixed').removeClass('cart-checkout-stick-bottom');
            }
        };

        handleStickyCheckoutButton($window);

        // Adapt on scroll / resize
        $window.on(
            'orientationchange resize scroll',
            debounce(function () {
                handleStickyCheckoutButton($(this));
            }, 10)
        );
    }

    // Add giveaway event in datalayer
    const $couponCode = $('#couponCode');
    var event = $couponCode && $couponCode.data('give-away-event');
    if (event && event !== null) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event);
    }
};
